<template>
  <div
    class="flex flex-col px-10 md:px-0 pt-24 md:pl-140px lg:pl-200px h-screen"
  >
    <div class="text-30px md:text-70px text-qwray font-Foco md:mt-24 font-bold">
      {{ $t('invoice.big_header') }}
    </div>
    <div
      class="bg-red-100 border border-qwray text-qwray px-4 py-3 rounded relative w-300px text-20px"
      :class="al ? '' : 'hidden'"
      role="alert"
    >
      <span class="block sm:inline">{{ $t('invoice.not_found') }}</span>
      <span
        class="absolute top-0 bottom-0 right-0 px-4 py-4"
        v-on:click="onAlertClose"
      >
        <svg
          class="fill-current h-6 w-6 text-red-500"
          role="button"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <title>Close</title>
          <path
            d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"
          />
        </svg>
      </span>
    </div>
    <form
      v-on:submit.prevent
      id="invoice"
      class="mt-10 h-full"
      autocomplete="off"
      data-form-type="other"
    >
      <div class="flex flex-col items-start py-2 h-full">
        <div class="text-14px md:text-20px text-qwray">
          {{ $t('invoice.date_header') }}
        </div>
        <div class="DateParent">
          <input
            class="appearance-none bg-transparent border-b-2 border-qwellow text-gray-700 mr-3 py-1 px-2 leading-tight focus:outline-none w-52 mt-2 DateInput"
            id="invoice-date"
            :placeholder="placeholder"
            :value="date"
            v-on:input="
              handelInput({ value: $event.target.value, type: 'input' })
            "
            required
            autocomplete="off"
            :pattern="regex"
            tabindex="1"
            data-lpignore="true"
            data-form-type="other"
          />
          <div class="Cal">
            <div class="Cal-Icon">
              <img src="~@/assets/calendar.svg" alt="Calendar Icon" />
            </div>
            <input
              class="DatePicker"
              id="invoice-date"
              :placeholder="placeholder"
              :value="
                calendarDate
                  .split(DATE_SYMBOL)
                  .reverse()
                  .join('-')
              "
              v-on:input="
                handelInput({ value: $event.target.value, type: 'calendar' })
              "
              required
              autocomplete="off"
              name="any-name"
              type="date"
              :pattern="regex"
              data-lpignore="true"
            />
          </div>
        </div>
        <div class="mt-10 text-14px md:text-20px text-qwray">
          {{ $t('invoice.invoice_header') }}
        </div>
        <input
          class="appearance-none bg-transparent border-b-2 border-qwellow text-gray-700 mr-3 py-1 px-2 leading-tight focus:outline-none w-32 mt-2"
          id="invoice-code"
          placeholder="XJSNDC"
          v-model="invoiceId"
          autocomplete="none"
          required
          tabindex="1"
          type="text"
          aria-label="Full name"
        />
        <button
          class="bg-qwellow text-16px text-qwray border-qwray rounded-full text-sm py-3 px-10 rounded md:mt-10 mt-auto mb-10 submitButton"
          type="submit"
          tabindex="1"
          v-on:click="onClick()"
        >
          {{ $t('invoice.submit_button') }}
        </button>
      </div>
    </form>
    <div></div>
  </div>
</template>

<script>
import { getLangFromRoute } from '../shared/languageHelpers';

export default {
  data() {
    return {
      invoiceId: '',
      placeholder: '',
      date: '',
      calendarDate: '',
      al: false,
      regex: '',
      DATE_SYMBOL: getLangFromRoute(this.$route.path) === 'de' ? '.' : '/',
    };
  },

  mounted() {
    this.placeholder =
      getLangFromRoute(this.$route.path) === 'de' ? 'DD.MM.YYYY' : 'DD/MM/YYYY';
    this.regex = `[0-9]{1,2}(\\${this.DATE_SYMBOL})[0-9]{1,2}(\\${this.DATE_SYMBOL})[0-9]{2,4}`;
  },
  methods: {
    // The calendar input expects the date to be in the yyyy-mm-dd format.
    // However, the user might type 1.1.21 which would not translate back to the yyyy-mm-dd format.
    createCalendarDate(displayDate) {
      const splitDisplayDate = displayDate.split(this.DATE_SYMBOL);
      const last = splitDisplayDate.length - 1;
      this.calendarDate = splitDisplayDate
        .map((value, i) => {
          // value -> DD | MM
          if (i < last) {
            if (value.length === 2) {
              return value;
            }
            // needs padding of 0 so that the user can just type something like -> 1.12.21 instead of 01.12.21
            return `0${value}`;
          }

          // value -> YYYY
          if (value.length === 2) {
            // add '20' so that the user can just type 21 instead of 2021
            return `20${value}`;
          }
          // Just return the value. No need for padding
          return value;
        })
        .join(this.DATE_SYMBOL);
    },
    handelInput(input) {
      if (input.type === 'input') {
        this.date = input.value;
      } else {
        this.date = input.value
          .split('-')
          .reverse()
          .join(this.DATE_SYMBOL);
      }
      this.createCalendarDate(input.value);
    },

    async onClick() {
      try {
        const ISODate = this.validateDate(this.date, this.DATE_SYMBOL);
        const formIsValid = document.getElementById('invoice').checkValidity();
        if (!ISODate || !this.invoiceId || !formIsValid) {
          return;
        }

        const response = await fetch(
          // eslint-disable-next-line
          `${process.env.VUE_APP_BACKEND_URL}/invoice/${ISODate}/${this.invoiceId}/`
        );
        if (response.status !== 200) {
          this.al = true;
        } else {
          const blob = await response.blob(); // download as Blob object
          window.location.href = URL.createObjectURL(blob);
        }
      } catch (err) {
        this.al = true;
      }
    },
    onAlertClose() {
      this.al = false;
    },
    validateDate(userInput, dateSymbol) {
      const [DD, MM, YYYY] = userInput.split(dateSymbol).filter(Boolean);

      try {
        new Intl.DateTimeFormat('en').format(new Date(YYYY, MM, DD));
      } catch (_e) {
        return null;
      }
      return `${YYYY}-${MM}-${DD}`;
    },
  },
};
</script>

<style scoped>
.submitButton {
  width: 100%;
}
@media (min-width: 678px) {
  .submitButton {
    width: auto;
  }
}
.DateParent {
  display: grid;
  place-items: center;
}
.DateParent > * {
  grid-area: 1 / 1;
}
.Cal {
  width: 30px;
  height: 30px;
  overflow: hidden;
  display: grid;
  align-self: flex-end;
  justify-self: flex-end;
  place-items: center;
  z-index: 100;
  position: relative;
}
.Cal > * {
  grid-area: 1 / 1;
}
.Cal-Icon {
  pointer-events: none;
  z-index: 1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.Cal-Icon img {
  pointer-events: none;
}
.DateInput {
  width: 100%;
  grid-column: 1;
  grid-row: 1;
  z-index: 10;
}
.DatePicker {
  width: 50px;
  opacity: 0;
  height: 30px;
  transform: translateX(-23px);
  pointer-events: all;
}
</style>
